import customAxios from "./axios";
import CONFIG from "../../config";
import * as types from "./types";

export const getJobData = (data) => ({
  type: types.JOB_DATA,
  data,
});

export const jobReferenceData = (data) => ({
  type: types.JOB_REFERENCE_DATA,
  data,
});

export const addJobReference = (data) => ({
  type: types.ADD_JOB_REFERENCE,
  data,
});

export const removeJobReference = (id) => ({
  type: types.REMOVE_JOB_REFERENCE,
  id,
});

export const uploadPaymentReceipt = (payload) => {
  return customAxios
    .post(CONFIG.documentURL + "/DocumentVault/ReceiptDocument/Upload", payload)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const getAll = (payload) => {
  return customAxios
    .post(CONFIG.apiURL + `/GetAllJobs`, payload)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const getIndividual = (id) => {
  return customAxios
    .get(CONFIG.apiURL + `/Jobs/JobDetails?jobId=${id}`)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const getIndividualJob = (id, limit, offset, status) => {
  return customAxios.get(CONFIG.apiURL + `/Jobs/JobsByCustomer?groupStatus=${status}&userID=${id}&limit=${limit}&offset=${offset}`).then((res) => {
    let response = res["data"];
    return response;
  });
};

export const create = (payload) => {
  return customAxios
    .post(CONFIG.apiURL + "/Jobs/Create", payload)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const update = (payload) => {
  return customAxios
    .put(CONFIG.apiURL + "/Jobs/Update", payload)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const getAllJobStatuses = (payload) => {
  return customAxios
    .get(CONFIG.apiURL + "/Jobs/GetAllJobStatuses", payload)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const createJobNote = (payload) => {
  return customAxios
    .post(CONFIG.apiURL + "/JobNote/CreateNote", payload)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const jobClosureApproval = (jobId, isApproved, comment) => {
  return customAxios
    .post(
      CONFIG.apiURL +
        `/Jobs/JobClosureApproval?jobId=${jobId}&isApproved=${isApproved}&comment=${comment}`
    )
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const updateReference = (payload) => {
  return customAxios
    .post(CONFIG.apiURL + "/Jobs/UpdateReference", payload)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const jobAttributes = (jobID) => {
  return customAxios
    .get(CONFIG.apiURL + `/ProcessCosts/DetailsByJob?jobId=${jobID}`)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const updateJobStatus = (payload) => {
  return customAxios
    .post(CONFIG.apiURL + "/Jobs/UpdateJobStatus", payload)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const updateReferenceStatus = (transactionNumber) => {
  return customAxios
    .post(
      CONFIG.apiURL +
        `/Jobs/CloseVendorTransaction?transactionNumber=${transactionNumber}`
    )
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const cancel = (payload) => {
  return customAxios
    .post(CONFIG.apiURL + "/Jobs/Cancel", payload)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const complete = (payload) => {
  return customAxios
    .post(CONFIG.apiURL + "/Jobs/Complete", payload)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const acceptJob = (payload) => {
  return customAxios
    .post(CONFIG.apiURL + "/Jobs/Accept", payload)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const declineJob = (payload) => {
  return customAxios
    .post(CONFIG.apiURL + "/Jobs/Decline", payload)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const downloadPaymentReceipt = (documentId) => {
  return customAxios
    .post(
      CONFIG.documentURL +
        `/DocumentVault/ReceiptDocument/Download?documentId=${documentId}`
    )
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const getMetaDataPaymentReceipt = (documentIds) => {
  return customAxios
    .get(
      CONFIG.documentURL +
        `/DocumentVault/ReceiptDocument/GetMetadata?documentIds=${documentIds}`
    )
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const getVendorDocumentMetaData = (documentIds) => {
  return customAxios
    .get(
      CONFIG.documentURL +
        `/DocumentVault/ReceiptDocument/GetMetadata?userId=2&documentIds=${documentIds}`
    )
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const getDocumentMetaData = (userID, documentIds) => {
  return customAxios
    .get(
      CONFIG.documentURL +
        `/DocumentVault/Document/GetMetadata?userId=${userID}&documentIds=${documentIds}`
    )
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const downloadDocument = (userID, documentID) => {
  return customAxios
    .get(
      CONFIG.documentURL +
        `/DocumentVault/Document/Download?userId=${userID}&documentId=${documentID}`
    )
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const downloadVendorDocument = (documentID) => {
  return customAxios
    .get(
      CONFIG.documentURL +
        `/DocumentVault/Document/Download?userId=2&documentId=${documentID}`
    )
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const downloadZipDocument = (payload) => {
  return customAxios
    .post(CONFIG.documentURL + `/DocumentVault/Document/MultiDownload`, payload)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const updateReferenceStatusModel = (payload) => {
  return customAxios
    .post(CONFIG.apiURL + `/Jobs/UpdateReferenceStatus`, payload)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const deliveryRequest = (payload) => {
  return customAxios
    .post(CONFIG.apiURL + `/DeliveryRequestJob/GetAll`, payload)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const getAllDeliveryTypeAndStatus = () => {
  return customAxios
    .get(CONFIG.apiURL + `/DeliveryRequestJob/GetAllDeliveryTypeAndStatus`)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const getSubProcessList = (jobId) => {
  // return customAxios.get(CONFIG.apiURL + `/Jobs/GetChildJobs?jobId=${jobId}`).then(res => {
  //     let response = res['data'];
  //     return response;
  // });
};

export const updateDeliveryRequest = (
  refNum,
  status,
  emiratePostReferenceNumber
) => {
  return customAxios
    .post(
      CONFIG.apiURL +
        `/DeliveryRequestJob/UpdateStatus/${refNum}?status=${status}&emiratePostReferenceNumber=${emiratePostReferenceNumber}`
    )
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const sendJobMail = (payload, jobId) => {
  return customAxios
    .post(CONFIG.apiURL + `/JobMail/SendJobDocuments?jobId=${jobId}`, payload)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const statusesForTypingCenter = (payload) => {
  return customAxios
    .get(CONFIG.apiURL + "/Jobs/StatusesForTypingCenter", payload)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const getAllSla = (payload) => {
  return customAxios
    .post(CONFIG.apiURL + `/JobSlaTrackers/GetAllSla`, payload)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const getCustomerInfoReport = (payload) => {
  return customAxios
    .post(CONFIG.apiURL + `/CallCenterReport/GetJobsReportByCustomers`, payload)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const getTransactionSummaryDetail = (payload) => {
  return customAxios
    .get(CONFIG.apiURL + `/Transactions/SummaryDetails?jobId=${payload}`)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const getAdditionalPaymentDetail = (jobID) => {
  return customAxios
    .get(CONFIG.apiURL + `/AdditionalPaymentRequests/GetByJob?jobID=${jobID}`)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const getAdditionalPaymentLogs = (jobID) => {
  return customAxios
    .get(CONFIG.apiURL + `/AdditionalPaymentLogsById/${jobID}`)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};
export const getPendingAdditionalPaymentDetail = (jobID) => {
  return customAxios
    .get(CONFIG.apiURL + `/AdditionalPaymentRequests/GetAdditionalPaymentPendingTransctionsByJob?jobId=${jobID}`)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const getCheckoutDetail = (jobID) => {
  return customAxios
    .get(CONFIG.apiURL + `/Jobs/Checkout?jobID=${jobID}`)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const getAdditionalPaymentCheckoutDetail = (requestId) => {
  return customAxios
    .get(CONFIG.apiURL + `/Jobs/CheckoutForAdditionalPayment?requestId=${requestId}`)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const checkoutForLink = (jobId) => {
  const params={"jobID": encodeURIComponent(jobId)};
  return customAxios.get(CONFIG.apiURL + `/Jobs/CheckoutForLink`,{params}).then(res => {
    return res;
  });
};
